import api from './api';

export type ThresholdUnifyStats = {
  pools_scanned: number;
  pools_updated: number;
  cctvs_scanned: number;
  cctvs_updated: number;
  cleared_pool_land: number;
  cleared_pool_ai_conf: number;
  cleared_pool_ai_hits: number;
  cleared_cctv_dwell: number;
  cleared_cctv_ai_conf: number;
  cleared_cctv_ai_hits: number;
  pool_ids: number[];
};

export type CctvThresholdUnifyStats = {
  pool_id: number;
  cctvs_scanned: number;
  cctvs_updated: number;
  cleared_dwell: number;
  cleared_ai_conf: number;
  cleared_ai_hits: number;
  reset_motion_to_pool: number;
};

export type UnifyFacilityThresholdsResponse = {
  success: boolean;
  stats: ThresholdUnifyStats;
  system_snapshot?: {
    risk_thresholds?: Record<string, number>;
    min_confidence?: number;
    min_track_hits?: number;
  };
};

export type UnifyPoolCctvThresholdsResponse = {
  success: boolean;
  stats: CctvThresholdUnifyStats;
  pool_snapshot?: {
    pool_id: number;
    pool_name?: string | null;
    special_zone_dwell_sec?: number;
    ai_detection_conf?: number;
    ai_detection_min_consecutive_hits?: number;
  };
};

/** 전역: 시설·CCTV → 시스템 「임계 설정」 승계 */
export async function unifyFacilityThresholdsToSystem(
  poolIds?: number[]
): Promise<UnifyFacilityThresholdsResponse> {
  const body =
    poolIds && poolIds.length > 0 ? { pool_ids: poolIds.map(Number) } : {};
  return api.post<UnifyFacilityThresholdsResponse>(
    '/api/settings/unify-facility-thresholds',
    body
  );
}

/** 시설: 소속 CCTV → 시설 임계 승계 */
export async function unifyCctvThresholdsToPool(
  poolId: number
): Promise<UnifyPoolCctvThresholdsResponse> {
  return api.post<UnifyPoolCctvThresholdsResponse>(
    `/api/pools/${Number(poolId)}/unify-cctv-thresholds`,
    {}
  );
}
